import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { getMAJAD010 } from '../../../services/Api';
import Calendar from '../../../shared/components/Calendar';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_STATISTICAL } from '../../../shared/constants/app';
registerLocale('ko', ko);

const MAJAD010 = () => {
    const today = moment().toDate();
    const [date, setDate] = useState(moment().subtract(1, 'day').toDate());
    const [monthlySummary, setMonthlySummary] = useState([]);
    const [dailySummary, setDailySummary] = useState([]);
    const [ticketPurchases, setTicketPurchases] = useState([]);
    const [sumMonthlySummary, setSumMonthlySummary] = useState({
        subHighlight2New: 0,
        recNew: 0,
        fixTotal: 0,
        highlightTotal: 0,
        recTotal: 0,
        subGrandOptNew: 0,
        subGrandNew: 0,
        hotNew: 0,
        grandOptTotal: 0,
        hotRecruitOptTotal: 0,
        subColor2New: 0,
        subIconNew: 0,
        subIcon2New: 0,
        hotTotal: 0,
        fixNew: 0,
        subHotRecruitOptNew: 0,
        subRecNew: 0,
        subColorNew: 0,
        highlight2New: 0,
        subPremiumOptNew: 0,
        subHighlightNew: 0,
        grandOptNew: 0,
        hotRecruitOptNew: 0,
        colorTotal: 0,
        iconTotal: 0,
        premiumOptTotal: 0,
        highlight2Total: 0,
        grandNew: 0,
        highlightNew: 0,
        color2New: 0,
        premiumNew: 0,
        subFixNew: 0,
        icon2New: 0,
        colorNew: 0,
        premiumOptNew: 0,
        year: 0,
        grandTotal: 0,
        iconNew: 0,
        subPremiumNew: 0,
        color2Total: 0,
        premiumTotal: 0,
        subHotNew: 0,
        icon2Total: 0,
    });
    const handleDateChange = (date) => {
        const dateFormat = date ? moment(date).format('YYYY/MM/DD') : moment().subtract(1, 'day').format('YYYY/MM/DD');
        setDate(dateFormat);
    };

    useEffect(() => {
        if (monthlySummary && monthlySummary.length > 0) {
            setSumMonthlySummary(
                monthlySummary.reduce(
                    (acc, item) => {
                        Object.keys(acc).forEach((key) => {
                            acc[key] += item[key] || 0; // Đảm bảo không bị undefined
                        });
                        return acc;
                    },
                    {
                        // Giá trị khởi tạo
                        subHighlight2New: 0,
                        recNew: 0,
                        fixTotal: 0,
                        highlightTotal: 0,
                        recTotal: 0,
                        subGrandOptNew: 0,
                        subGrandNew: 0,
                        hotNew: 0,
                        grandOptTotal: 0,
                        hotRecruitOptTotal: 0,
                        subColor2New: 0,
                        subIconNew: 0,
                        subIcon2New: 0,
                        hotTotal: 0,
                        fixNew: 0,
                        subHotRecruitOptNew: 0,
                        subRecNew: 0,
                        subColorNew: 0,
                        highlight2New: 0,
                        subPremiumOptNew: 0,
                        subHighlightNew: 0,
                        grandOptNew: 0,
                        hotRecruitOptNew: 0,
                        colorTotal: 0,
                        iconTotal: 0,
                        premiumOptTotal: 0,
                        highlight2Total: 0,
                        grandNew: 0,
                        highlightNew: 0,
                        color2New: 0,
                        premiumNew: 0,
                        subFixNew: 0,
                        icon2New: 0,
                        colorNew: 0,
                        premiumOptNew: 0,
                        year: 0,
                        grandTotal: 0,
                        iconNew: 0,
                        subPremiumNew: 0,
                        color2Total: 0,
                        premiumTotal: 0,
                        subHotNew: 0,
                        icon2Total: 0,
                    },
                ),
            );
        }
    }, [monthlySummary]);

    useEffect(() => {
        const dateFormat = date ? moment(date).format('YYYYMMDD') : null;
        getMAJAD010(dateFormat)
            .then((data) => {
                setMonthlySummary(data.data.monthlySummary);
                setDailySummary(
                    data.data.dailySummary.map((item) => ({
                        sdate: item.date,
                        value: item.totalRecruit,
                    })),
                );

                setTicketPurchases(data.data.ticketPurchases);
            })
            .catch((error) => console.log(error));
    }, [date]);
    return (
        <div className="statis-page">
            <div className="container-fluid container">
                <div className="content wrap">
                    <SideMenu menu={MENU_STATISTICAL} />
                    <div className=" content-right">
                        <div className="title">이용권등록</div>
                        <div>
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th style={{ width: 150 }}>일자</th>
                                        <td colSpan={3} style={{ textAlign: 'left' }}>
                                            <DatePicker
                                                style={{ width: 200 }}
                                                onChange={(date) => handleDateChange(date, 'date')}
                                                locale="ko"
                                                placeholderText="YYYY/MM/DD"
                                                dateFormat="yyyy/MM/dd"
                                                selected={date}
                                                maxDate={today}
                                                showYearDropdown
                                                showMonthDropdown
                                                scrollableYearDropdown
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="group-button center">
                                <button className="btn btn-gray-bold">검색</button>
                                <button className="btn btn-gray-thin">초기화</button>
                            </div>
                        </div>
                        <div className="table-padding-5">
                            <div className="count-item">
                            </div>
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th rowSpan={3}>구분</th>
                                        <th colSpan={2} rowSpan={1}>
                                            구인등록
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            그랜드배너
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            프리미엄배너
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            핫리쿠르트
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            채용소식
                                            <br />
                                            고정옵션
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            그랜드
                                            <br />
                                            고정옵션
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            프리미엄
                                            <br />
                                            고정옵션
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            핫리쿠르트
                                            <br />
                                            고정옵션
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            하이라이트
                                            <br />
                                            강조 1주
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            하이라이트
                                            <br />
                                            강조 2주
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            컬러
                                            <br />
                                            강조 1주
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            컬러
                                            <br />
                                            강조 2주
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            아이콘
                                            <br />
                                            강조 1주
                                        </th>
                                        <th colSpan={2} rowSpan={1}>
                                            아이콘
                                            <br />
                                            강조 2주
                                        </th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                        <th colSpan={2}>2026년</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                        <th colSpan={1}>전체</th>
                                        <th colSpan={1}>신/누</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {monthlySummary &&
                                        monthlySummary.length > 0 &&
                                        monthlySummary.map((item, index) => {
                                            return (
                                                <tr key={`monthlySummary-${index}`}>
                                                    <td>{`${item.month}월`}</td>
                                                    <td>{item.recTotal}</td>
                                                    <td>{item.subRecNew}/{`${item.recNew}`}</td>
                                                    <td>{item.grandTotal}</td>
                                                    <td>{`${item.subGrandNew}/${item.grandNew}`}</td>
                                                    <td>{item.premiumTotal}</td>
                                                    <td>{`${item.subPremiumNew}/${item.premiumNew}`}</td>
                                                    <td>{item.hotTotal}</td>
                                                    <td>{`${item.subHotNew}/${item.hotNew}`}</td>
                                                    <td>{item.fixTotal}</td>
                                                    <td>{`${item.subFixNew}/${item.fixNew}`}</td>
                                                    <td>{item.grandOptTotal}</td>
                                                    <td>{`${item.subGrandOptNew}/${item.grandOptNew}`}</td>
                                                    <td>{item.premiumOptTotal}</td>
                                                    <td>{`${item.subPremiumNew}/${item.premiumOptNew}`}</td>
                                                    <td>{item.hotRecruitOptTotal}</td>
                                                    <td>{`${item.subHotRecruitOptNew}/${item.hotRecruitOptNew}`}</td>
                                                    <td>{item.highlightTotal}</td>
                                                    <td>{`${item.subHighlightNew}/${item.highlightNew}`}</td>
                                                    <td>{item.highlight2Total}</td>
                                                    <td>{`${item.subHighlight2New}/${item.highlight2New}`}</td>
                                                    <td>{item.colorTotal}</td>
                                                    <td>{`${item.subColorNew}/${item.colorNew}`}</td>
                                                    <td>{item.color2Total}</td>
                                                    <td>{`${item.subColor2New}/${item.color2New}`}</td>
                                                    <td>{item.iconTotal}</td>
                                                    <td>{`${item.subIconNew}/${item.iconNew}`}</td>
                                                    <td>{item.icon2Total}</td>
                                                    <td>{`${item.subIcon2New}/${item.icon2New}`}</td>
                                                </tr>
                                            );
                                        })}
                                    {monthlySummary &&
                                        monthlySummary.length < 12 &&
                                        Array.from({ length: 12 - monthlySummary.length }).map((_, i) => (
                                            <tr key={i}>
                                                {Array.from({ length: 29 }).map((_, j) => (
                                                    <td key={j}></td>
                                                ))}
                                            </tr>
                                        ))}
                                    {sumMonthlySummary && (
                                        <tr>
                                            <td>Total</td>
                                            <td>{sumMonthlySummary.recTotal}</td>
                                            <td>{`${sumMonthlySummary.recNew}/${sumMonthlySummary.subRecNew}`}</td>
                                            <td>{sumMonthlySummary.grandTotal}</td>
                                            <td>{`${sumMonthlySummary.subGrandNew}/${sumMonthlySummary.grandNew}`}</td>
                                            <td>{sumMonthlySummary.premiumTotal}</td>
                                            <td>{`${sumMonthlySummary.subPremiumNew}/${sumMonthlySummary.premiumNew}`}</td>
                                            <td>{sumMonthlySummary.hotTotal}</td>
                                            <td>{`${sumMonthlySummary.subHotNew}/${sumMonthlySummary.hotNew}`}</td>
                                            <td>{sumMonthlySummary.fixTotal}</td>
                                            <td>{`${sumMonthlySummary.subFixNew}/${sumMonthlySummary.fixNew}`}</td>
                                            <td>{sumMonthlySummary.grandOptTotal}</td>
                                            <td>{`${sumMonthlySummary.subGrandOptNew}/${sumMonthlySummary.grandOptNew}`}</td>
                                            <td>{sumMonthlySummary.premiumOptTotal}</td>
                                            <td>{`${sumMonthlySummary.subPremiumNew}/${sumMonthlySummary.premiumOptNew}`}</td>
                                            <td>{sumMonthlySummary.hotRecruitOptTotal}</td>
                                            <td>{`${sumMonthlySummary.subHotRecruitOptNew}/${sumMonthlySummary.hotRecruitOptNew}`}</td>
                                            <td>{sumMonthlySummary.highlightTotal}</td>
                                            <td>{`${sumMonthlySummary.subHighlightNew}/${sumMonthlySummary.highlightNew}`}</td>
                                            <td>{sumMonthlySummary.highlight2Total}</td>
                                            <td>{`${sumMonthlySummary.subHighlight2New}/${sumMonthlySummary.highlight2New}`}</td>
                                            <td>{sumMonthlySummary.colorTotal}</td>
                                            <td>{`${sumMonthlySummary.subColorNew}/${sumMonthlySummary.colorNew}`}</td>
                                            <td>{sumMonthlySummary.color2Total}</td>
                                            <td>{`${sumMonthlySummary.subColor2New}/${sumMonthlySummary.color2New}`}</td>
                                            <td>{sumMonthlySummary.iconTotal}</td>
                                            <td>{`${sumMonthlySummary.subIconNew}/${sumMonthlySummary.iconNew}`}</td>
                                            <td>{sumMonthlySummary.icon2Total}</td>
                                            <td>{`${sumMonthlySummary.subIcon2New}/${sumMonthlySummary.icon2New}`}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="flex-table" style={{ gap: '30px' }}>
                                <Calendar data={dailySummary} date={moment(date).format('YYYY-MM-DD')} />
                                <div className="right-table table-list-status">
                                    <table className="table table-gray">
                                        <thead>
                                            <tr>
                                                <th colSpan={3}>회원별 구매현황</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ticketPurchases &&
                                                ticketPurchases.length > 0 &&
                                                ticketPurchases.map((item, index) => {
                                                    return (
                                                        <tr key={`ticketPurchases-${index}`}>
                                                            <td>{item.memberID}</td>
                                                            <td>{item.goodName}</td>
                                                            <td>{item.count}</td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAJAD010;
